import { render } from "./video-container.vue?vue&type=template&id=0cfe5635"
import script from "./video-container.vue?vue&type=script&lang=js"
export * from "./video-container.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__